export default __webpack_public_path__ + "static/media/online-order-ring.a673b70c.wav";